import '../scss/main.sass';
import './poi-map.js';

// Tag <body> on hero-overlay pages so SCSS can swap the Houzez in-flow header
// for a fixed-position frosted-glass overlay. Read state synchronously so the
// class is in place before first paint and the page never renders with the
// in-flow header height occupying space at the top.
(() => {
    const header = document.querySelector('header.header-main-wrap');
    if (header && header.classList.contains('header-transparent-wrap')) {
        document.documentElement.classList.add('has-transparent-header');
    }
})();

// Lift the back-to-top arrow above the footer so it doesn't sit on top of the
// "Livro de Reclamações" / Complaints Book block when the user scrolls to the
// bottom of the page. We observe the footer with IntersectionObserver and
// toggle `.is-near-footer` on `.back-to-top-wrap` while the footer is in view.
(() => {
    const backToTop = document.querySelector('.back-to-top-wrap');
    const footer = document.querySelector('footer.footer-wrap');

    if (!backToTop || !footer || !('IntersectionObserver' in window)) {
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            backToTop.classList.toggle('is-near-footer', entry.isIntersecting);
        }
    }, { threshold: 0 });

    observer.observe(footer);
})();

// Make Elementor background videos autoplay reliably across browsers,
// especially mobile Safari/Chrome. Browsers only allow autoplay on videos
// that are explicitly muted *and* playsinline; Elementor sets these markup
// attributes but injects the <src> lazily, and some browsers race the play()
// call against the src assignment. We re-assert the required properties,
// retry play() on every loadeddata/canplay event, and as a last resort
// defer play() to the first user gesture if the browser still blocks it.
(() => {
    const SELECTOR = 'video.elementor-background-video-hosted';

    const setup = (video) => {
        if (!video || video.dataset.bgVideoBound) return;
        video.dataset.bgVideoBound = '1';

        // Re-assert the autoplay prerequisites at both property and attribute
        // level. iOS Safari historically only honoured `playsinline` when
        // present as an attribute; some Android Chromiums only honour
        // `defaultMuted` when set as a property.
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('preload', 'auto');

        let gestureBound = false;
        const onGesture = () => {
            video.play().catch(() => {});
        };

        const tryPlay = () => {
            const p = video.play();
            if (!p || typeof p.catch !== 'function') return;
            p.catch(() => {
                if (gestureBound) return;
                gestureBound = true;
                window.addEventListener('touchstart', onGesture, { once: true, passive: true });
                window.addEventListener('click', onGesture, { once: true });
            });
        };

        video.addEventListener('loadeddata', tryPlay);
        video.addEventListener('canplay', tryPlay);
        if (video.readyState >= 2) tryPlay();
    };

    document.querySelectorAll(SELECTOR).forEach(setup);

    // Elementor inserts background videos after first paint; watch for them.
    if ('MutationObserver' in window) {
        new MutationObserver((mutations) => {
            for (const m of mutations) {
                for (const node of m.addedNodes) {
                    if (!(node instanceof Element)) continue;
                    if (node.matches && node.matches(SELECTOR)) {
                        setup(node);
                    } else if (node.querySelectorAll) {
                        node.querySelectorAll(SELECTOR).forEach(setup);
                    }
                }
            }
        }).observe(document.documentElement, { childList: true, subtree: true });
    }
})();